// The announcement strip at the very top of the site, set from Discord with the bot's ?banner command.
// The text arrives exactly as typed there: line breaks, [Label](link) buttons and Discord's custom emoji codes
// (<:name:id>, or <a:name:id> when animated). Ordinary emoji are already plain characters.

const PIECES = /\[([^\]]*)\]\(([^)\s]+)\)|<(a?):([A-Za-z0-9_]+):(\d+)>/g;

const Emoji = ({ animated, name, id }) => (
  <img
    src={`https://cdn.discordapp.com/emojis/${id}.${animated ? 'gif' : 'webp'}?size=48`}
    alt={`:${name}:`}
    title={name}
    className="inline-block object-contain"
    style={{ height: '1.45em', width: 'auto', margin: '0 0.1em', verticalAlign: '-0.35em' }}
  />
);

// Splits one line into its runs of text (with their emoji) and its buttons, in order
const parseLine = (line) => {
  const parts = [];
  const addToText = (piece) => {
    const previous = parts[parts.length - 1];
    if (previous && previous.type === 'text') previous.content.push(piece);
    else parts.push({ type: 'text', content: [piece] });
  };
  let index = 0;
  for (const match of line.matchAll(PIECES)) {
    if (match.index > index) addToText(line.slice(index, match.index));
    if (match[1] !== undefined) {
      parts.push({ type: 'link', label: match[1], url: match[2] });
    } else {
      addToText(<Emoji key={match.index} animated={!!match[3]} name={match[4]} id={match[5]} />);
    }
    index = match.index + match[0].length;
  }
  if (index < line.length) addToText(line.slice(index));
  return parts;
};

// Links back into this site's own tabs switch tab instead of reloading the page
const internalTab = (url, resolveTab) => {
  if (!/^(https?:\/\/(www\.)?cheeks\.uk)?\/?#/.test(url)) return null;
  return resolveTab(url.split('#')[1]);
};

export default function SiteBanner({ text, resolveTab, onOpenTab }) {
  const lines = text.split(/\r?\n/).map((line) => line.trim()).filter(Boolean);
  return (
    <div className="relative z-50 flex flex-col items-center gap-1 py-2 px-4 bg-gradient-to-br from-zinc-800/85 to-black/90 backdrop-blur-lg border-b border-zinc-700/70">
      {lines.map((line, i) => (
        // Each line is centred as a row, so wrapped text and its buttons always stay lined up
        <div key={i} className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1.5 max-w-full">
          {parseLine(line).map((part, j) => {
            if (part.type === 'text') {
              return <span key={j} className="text-white text-center font-medium tracking-wide min-w-0" style={{ fontSize: '11px', lineHeight: 1.45 }}>{part.content}</span>;
            }
            const tab = internalTab(part.url, resolveTab);
            return (
              <a
                key={j}
                href={part.url}
                onClick={tab ? (e) => { e.preventDefault(); onOpenTab(tab); } : undefined}
                className="inline-flex items-center justify-center text-white font-bold whitespace-nowrap transition-all hover:brightness-110 active:scale-95"
                style={{ fontSize: '10px', lineHeight: 1, letterSpacing: '0.03em', padding: '5px 10px', borderRadius: '4px', background: 'linear-gradient(135deg,#04aff7,#f42ae4)' }}
              >
                {part.label}
              </a>
            );
          })}
        </div>
      ))}
    </div>
  );
}
